import React, { useState, useEffect } from 'react';
import './Slate.css';

const Slate = () => {
  const [text, setText] = useState('');
  const [voiceOptions, setVoiceOptions] = useState([]);
  const [selectedVoice, setSelectedVoice] = useState(null);

  useEffect(() => {
    const synth = window.speechSynthesis;
    const voices = synth.getVoices();
    setVoiceOptions(voices);
  }, []);

  const handleVoiceChange = (e) => {
    const selected = voiceOptions.find((voice) => voice.name === e.target.value);
    setSelectedVoice(selected);
  };

  const readText = () => {
    const synth = window.speechSynthesis;
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = 0.55; // Adjust this value to control the speed
    if (selectedVoice) {
      utterance.voice = selectedVoice;
    }
    synth.speak(utterance);
};
const openUrl = () => {
    window.open('https://draftj.in', '_blank');
}
const clearBoard = () => {
  // setBoard([...originalBoard]);
  window.location.reload();
 };
  return (
    <div className="Appslate">
      <br/><br/>  
      <h1>Digital SLATE<button onClick={clearBoard}>Clean the Slate</button></h1>
      <br/>
       <h2>Write a word, phrase, or number on the digital slate. Select a voice and click ‘Read Text’ to help kids hear and learn in a fun way!</h2>
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Enter text here..."
      />
      <select onChange={handleVoiceChange}>
        <option value="">Select Voice</option>
        {voiceOptions.map((voice, index) => (
          <option key={index} value={voice.name}>
            {voice.name} ({voice.lang})
          </option>
        ))}
      </select>
      <button className="slateb" onClick={readText}>Read Text</button>
    </div>
  );
};

export default Slate;
